module.exports = __webpack_public_path__ + "static/media/indrive.bdcedea3.svg";